import { reduce } from "et3-type-guards";
import { TalkhattabatConversationType } from "../../../../../../../Types";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../../../../core/et3-input/et3-text-input";
import getKhattabatStore from "../../../../../../../stores/khattabat-stores";

const CreateOneOTwoField = withLiteObserverAndTheme<{
  conversationID: string;
  conversationType: TalkhattabatConversationType;
}>((props) => {
  const { theme, conversationType, conversationID } = props;
  const { unitX, unitY } = theme;
  const isOneOOneCConversation = conversationType === "101C";
  const shouldShow = isOneOOneCConversation;
  return shouldShow ? (
    <ET3Div
      width={180}
      height={43}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        borderRadius: 36 * unitX,
        cursor: "pointer",
        overflow: "hidden"
      }}
      color={""}
      justifyContent={"center"}
      withShadow={true}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <Et3TextInput
        size="SMALL"
        withShadow={false}
        placeHolder={"Insert User ID"}
        icon={"function"}
        label={""}
        style={{
          width: 180 * unitX,
          height: 43 * unitY
        }}
        value={reduce(
          () =>
            getKhattabatStore().conversationsProps.get(conversationID)
              .insertUserIdField,
          -1
        )}
        onChoose={(fieldValue: number) => {
          getKhattabatStore().updateConversationProp({
            value: fieldValue,
            propKey: "insertUserIdField",
            conversationID
          });
        }}
        onBlur={() => {}}
        type={"number"}
        onEnter={() => {}}
      />
    </ET3Div>
  ) : null;
});

export default CreateOneOTwoField;
